var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 8,
    y: 10,
    fill: "#fff",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m-49.852 53 42.427-42.426L6.717 24.716-35.71 67.142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "M-7.425 10.574 35-31.853 49.143-17.71 6.717 24.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE5",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "M-14.496 45.929 6.717 24.715 20.86 38.858-.354 60.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m6.717 24.716 42.426-42.427L63.285-3.569 20.86 38.858zM-21.567 81.284-.354 60.07l14.142 14.142-21.213 21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m-.354 60.07 21.213-21.212L35.001 53 13.788 74.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "M20.859 38.858 63.285-3.57l14.143 14.142L35 53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "M-7.425 95.426 35 52.999l14.142 14.142-42.426 42.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE5",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m35 53 21.214-21.213 14.142 14.142-21.213 21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m56.214 31.787 21.213-21.213L91.57 24.716 70.356 45.929z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE5",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m27.93 88.355 42.426-42.427 14.142 14.143-42.426 42.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE5",
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "M42.072 102.497 84.498 60.07 98.64 74.213l-42.426 42.426z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 22,
    height: 30,
    x: 24,
    y: 22,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 22h22v30H24z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36.326 50.22C39.046 47.247 45 39.945 45 33c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 6.945 5.954 14.247 8.674 17.22a1.778 1.778 0 0 0 2.652 0ZM35 37a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.326 50.22C39.046 47.247 45 39.945 45 33c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 6.945 5.954 14.247 8.674 17.22a1.778 1.778 0 0 0 2.652 0ZM35 37a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC3D00",
    d: "m36.326 50.22.738.675-.738-.675Zm-2.652 0-.738.675.738-.675ZM44 33c0 3.208-1.385 6.584-3.176 9.587-1.78 2.985-3.9 5.498-5.236 6.958l1.476 1.35c1.385-1.514 3.602-4.138 5.478-7.283C44.407 40.484 46 36.736 46 33h-2Zm-9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11v2Zm-9 9a9 9 0 0 1 9-9v-2c-6.075 0-11 4.925-11 11h2Zm8.412 16.545c-1.335-1.46-3.455-3.973-5.236-6.958C27.385 39.584 26 36.208 26 33h-2c0 3.736 1.593 7.484 3.458 10.612 1.877 3.145 4.093 5.77 5.478 7.283l1.476-1.35Zm1.176 0a.779.779 0 0 1-1.176 0l-1.476 1.35a2.778 2.778 0 0 0 4.128 0l-1.476-1.35ZM38 33a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5h-2Zm-3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5v2Zm-3 3a3 3 0 0 1 3-3v-2a5 5 0 0 0-5 5h2Zm3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5v-2Z",
    mask: "url(#b)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 8.5,
    y: 10.5,
    stroke: "#E3E8EF",
    rx: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 8,
    y: 10,
    fill: "#fff",
    rx: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.a67ea5d45fc8fa84754d11a409af1f33.svg";
export { ForwardRef as ReactComponent };